import { render, staticRenderFns } from "./DocentePreasignacion.vue?vue&type=template&id=37bf7014&"
import script from "./DocentePreasignacion.vue?vue&type=script&lang=js&"
export * from "./DocentePreasignacion.vue?vue&type=script&lang=js&"
import style0 from "./DocentePreasignacion.vue?vue&type=style&index=0&id=37bf7014&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports